import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Process from '../components/Process';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEOHelmet from '../components/SEOHelmet';
import { pagesSEO } from '../utils/seoConfig';
import '../styles/Home.css';

const Home = () => {
  return (
    <div className="home">
      <SEOHelmet 
        title={pagesSEO.home.title}
        description={pagesSEO.home.description}
        keywords={pagesSEO.home.keywords}
        canonical={pagesSEO.home.canonical}
        includeOrganizationData={true}
        includeLocalBusinessData={true}
      />
      <Navbar />
      <main>
        <h1 className="page-title sr-only">聯漢室內設計工作室 - 專業室內設計服務</h1>
        <section id="hero-section" className="section-container">
          <Hero />
        </section>
        <section id="about" className="section-container">
          <About />
        </section>
        <section id="services" className="section-container">
          <Services />
        </section>
        <section id="process" className="section-container">
          <Process />
        </section>
        <section id="projects" className="section-container">
          <Projects />
        </section>
        <section id="contact" className="section-container">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Home; 